import { render, staticRenderFns } from "./SomosSecurity.vue?vue&type=template&id=541d685e"
import script from "./SomosSecurity.vue?vue&type=script&lang=js"
export * from "./SomosSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports